import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from '../shared/google-tag-manager.service';
import { AuthenticationRnecService } from '../authentication-rnec/services/authentication-rnec.service';
import { RedirectService } from '../shared/redirect.service';
import { environment } from '../../../environments/environment';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { NewServiceErrorEnum } from '../enums/new-service-error.enum';
import { EventsService } from '../shared/bdb-event.service';
import { RnecAgentModel } from '../authentication-rnec-v2/model/RnecAgent.model';
import { BdbDialogoComponent } from '../../webcomponents/bdb-dialogo/bdb-dialogo.component';
import { ErrorCode } from '../models/error-codes-v2';

@Component({
    selector: 'app-bdb-regulation-rnec',
    templateUrl: './bdb-regulation-rnec.component.html',
    styleUrls: ['./bdb-regulation-rnec.component.css']
})
export class BdbRegulationRnecComponent implements OnInit, AfterViewInit {

    @ViewChild('loader') loaderBdb: ElementRef;
    @ViewChild('modal') modalBdb: ElementRef;
    modalFunctionYes: Function;

    @ViewChild('errorAgentConexion') errorAgentConexion: BdbDialogoComponent;

    @Input() checkRegulationRnec = false;

    bodyFormatRnec: string = '';
    titleFormatRnec: string = '';
    hardware: string;
    newVersionAgent: boolean = false;
    newAgent: RnecAgentModel;
    // @ts-ignore
    tempErrorAgentConexion: NodeJS.Timer;
    intentosConexion: number = 1;

    constructor(
        private readonly authService: AuthenticationRnecService,
        private readonly googleTagManagerService: GoogleTagManagerService,
        private readonly redirectService: RedirectService,
        private readonly routes: Router,
        private readonly eventService: EventsService,
        private readonly bdbSessionStrgService: BdbSessionStrgService
    ) {
        this.newAgent = new RnecAgentModel();
    }

    ngOnInit() {
        this.hardware = this.bdbSessionStrgService.get(SessionStorageKeysEnum.HARDWARE);

        if (!this.hardware) {
            return this.redirectService.redirectToError(ErrorCode.HARDWARE_NOT_FOUND, 'v2');
        }

        if (environment.isEnableControlAdviser) {
            const isValidCaptureFinger = this.isValidCaptureFinger()
            if (!isValidCaptureFinger) {
                this.redirectService.redirectToError(NewServiceErrorEnum.BLOCKING_BY_ASSESSOR_CERTIFICATE);
            }
        }
        this.googleTagManagerService.sendInfo(window.location.pathname, 'Autorización');
        window.scrollTo(0, 0);
    }

    async ngAfterViewInit(): Promise<void> {
        this.callModalLoading();

        const params = {
            status: 'ok'
        };

        const response = await this.authService.regulationFromRnec(params);

        if (response.status === 200) {
            const data = response.body;
            const messageRnec = data.message.replace(/"/g, '');
            const parseMessage = messageRnec.split('\\r\\n');
            this.titleFormatRnec = parseMessage[0];
            this.bodyFormatRnec = messageRnec.substring(parseMessage[0].length, messageRnec.length).replace(/\\r\\n/g, ' ');
        } else {
            this.titleFormatRnec = '';
            this.bodyFormatRnec = '';
        }
        this.loaderBdb.nativeElement.closeLoader();
    }

    isValidCaptureFinger(): boolean {
        const sellerDocumentLauncher = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LAUNCHER);
        const sellerDocumentLDAP = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LDAP);
        const sellerDocument = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER);
        const userDocumentNumber = this.bdbSessionStrgService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const isValidVsLauncher = (sellerDocumentLauncher !== userDocumentNumber);
        const isValidVsLDAP = (sellerDocumentLDAP !== userDocumentNumber);
        const isValidVsOffice = (sellerDocument !== userDocumentNumber);
        console.log(`Is valid capture finger `, { isValidVsLauncher, isValidVsLDAP, isValidVsOffice });
        return isValidVsLauncher && isValidVsLDAP && isValidVsOffice
    }

    valCheck() {
        this.checkRegulationRnec = !this.checkRegulationRnec;
    }

    async continueAutentication() {
        this.callModalLoading();
        this.eventService.reportEvent('acceptTermsAuth', ' ', 'ok', null, null, null)
        if (this.hardware === 'new') {
            try {
                const documentNumber = this.bdbSessionStrgService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
                await this.newAgent.startGetTermsAndConditions(documentNumber);
                const { Version, CodigoVersion, Error: error } = await this.newAgent.getCaptorVersion();
                if (!!error && String(error) === '400') {
                    this.loaderBdb.nativeElement.closeLoader();
                    this.errorAgentConexion.openDialogue();
                    this.tempErrorAgentConexion = setInterval(this.setErrorConexionModalInfo.bind(this), 4000);
                } else {
                    this.newVersionAgent = (CodigoVersion !== -1) && Version !== '';
                    this.bdbSessionStrgService.save(SessionStorageKeysEnum.IS_NEW_AGENT_VERSION, String(this.newVersionAgent));
                    console.log('New version Captor --->', this.newVersionAgent);
                    if (this.newVersionAgent) {
                        this.routes.navigate(['rnec-v2']);
                    } else {
                        this.routes.navigate(['rnec']);
                    }
                }
            } catch (e) {
                this.bdbSessionStrgService.save('captorStatus', 'off');
                this.modalFunctionYes = this.closeModal;
                this.setModalTitles(
                    'Biométrico desactivado',
                    'Para continuar, es requerido que el biométrico se encuentre activado.'
                );
                this.loaderBdb.nativeElement.closeLoader();
                this.modalBdb.nativeElement.optionsButtons = [
                    { id: '0', value: 'Activar' }
                ];
                this.modalBdb.nativeElement.openAlert();
            }
        } else {
            this.loaderBdb.nativeElement.closeLoader();
            this.routes.navigate(['rnec']);
        }
    }

    closeModal(): void {
        const statusCaptor = this.bdbSessionStrgService.get('captorStatus');
        if (statusCaptor && statusCaptor === 'off') {
            this.callModalLoading();
            this.bdbSessionStrgService.delete('captorStatus');
            window.open(`olimpiait://reconoser?security='https'`);
            setTimeout(() => {
                this.loaderBdb.nativeElement.closeLoader();
                location.reload()
            }, 8000);
        }
    }

    optionBack() {
        this.routes.navigate([history.back()]);
    }

    optionQuit() {
        this.redirectService.quit();
    }

    private async setErrorConexionModalInfo() {
        const { Error: error } = await this.newAgent.getCaptorVersion();
        if (error) {
            this.intentosConexion++
            if (this.intentosConexion > 10) {
                clearInterval(this.tempErrorAgentConexion);
                this.errorAgentConexion.closeDialogue();
                this.redirectService.redirectToError(NewServiceErrorEnum.CONNECTION_ERROR);
            }
        } else {
            clearInterval(this.tempErrorAgentConexion);
            this.errorAgentConexion.closeDialogue();
            this.continueAutentication()
        }
    }

    callModalLoading() {
        this.loaderBdb.nativeElement.openLoader();
    }

    setModalTitles(title: string, subtitle: string) {
        this.modalBdb.nativeElement.titleModal = title
        this.modalBdb.nativeElement.subTitle = subtitle
    }

    actionButtomModalBdb() {
        this.modalFunctionYes()
    }

}



// WEBPACK FOOTER //
// ./src/app/bdb-regulation-rnec/bdb-regulation-rnec.component.ts